import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { ComponentProps, MouseEvent } from 'react'
import { Link } from 'react-router-dom'

import cn from '@/utilities/cn'

type Breadcrumb = {
  label: string
  path?: string
  onClick?: () => void
}
type BreadcrumbsProps = {
  breadcrumbs: Breadcrumb[]
}
export default function Breadcrumbs({ breadcrumbs, ...rest }: BreadcrumbsProps & ComponentProps<'nav'>) {
  const handleClick = async (e: MouseEvent<HTMLElement>, breadcrumb: Breadcrumb) => {
    if (breadcrumb.onClick) {
      e.preventDefault()
      breadcrumb?.onClick()
    }
  }

  return (
    <nav aria-label="Breadcrumb" {...rest}>
      <ol className="flex items-center space-x-2">
        {breadcrumbs.map((breadcrumb, i) => {
          return (
            <li key={`${breadcrumb.label}-${i}`}>
              {breadcrumb.path ? (
                <Link
                  to={breadcrumb.path}
                  onClick={e => handleClick(e, breadcrumb)}
                  className="text-gray-400 hover:text-gray-500"
                >
                  {i === 0 ? (
                    breadcrumb.label
                  ) : (
                    <div className="flex items-center">
                      <ChevronRightIcon className="h-4 w-4 flex-shrink-0 text-gray-400" aria-hidden="true" />
                      <p
                        className={cn('ml-2 text-sm font-medium', {
                          'text-gray-700': i === breadcrumbs.length - 1
                        })}
                      >
                        {breadcrumb.label}
                      </p>
                    </div>
                  )}
                </Link>
              ) : i === 0 ? (
                breadcrumb.label
              ) : (
                <div className="flex items-center">
                  <ChevronRightIcon className="h-4 w-4 flex-shrink-0 text-gray-400" aria-hidden="true" />
                  <p
                    className={cn('ml-2 text-sm font-medium', {
                      'text-gray-700': i === breadcrumbs.length - 1
                    })}
                  >
                    {breadcrumb.label}
                  </p>
                </div>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
